@if (data$ | async; as data) {
  <div class="navbar" [ngClass]="{ 'navbar--no-header': data.isHeaderHidden }">
    @for (item of navItems; track item.label) {
      <lh-navigation-item
        [item]="item"
        [isSelected]="item === selectedNavItem"
        [isActive]="data.currentUrl | isNavItemActive: item"
        (clicked)="selectNavItem(item)"
      />
    }
  </div>

  <p-sidebar
    #sidebar
    class="nav-menu"
    [ngClass]="{ 'nav-menu--top-sticked': data.isHeaderHidden, 'nav-menu--pinned': data.isNavigationPinned }"
    [visible]="data.isNavigationOpened"
    [modal]="!data.isNavigationPinned"
    (visibleChange)="onVisibilityChange($event)"
    [position]="data.isDesktop ? 'left' : 'bottom'"
    [baseZIndex]="NAVIGATION_SIDEBAR_BASE_Z_INDEX"
    transitionOptions="100ms linear"
    [showCloseIcon]="false"
  >
    <ng-template pTemplate="header">
      <div class="nav-menu__header">
        <h2 class="nav-menu__header-title">{{ selectedNavItem?.label || 'title' }}</h2>
        <div class="nav-menu__header-action-control">
          <div class="nav-menu__pin-btn">
            @if (data.isNavigationPinned) {
              <i class="fas fa-thumbtack" (click)="unpinNavigation()"></i>
            } @else {
              <i class="far fa-thumbtack" (click)="pinNavigation()"></i>
            }
          </div>
          <i class="fal fa-times nav-menu__close-btn" (click)="closeNavMenu()"></i>
        </div>
      </div>

      @if (selectedNavItem?.subNav?.items | showAfter: 10) {
        <p-iconField iconPosition="right">
          @if (searchString.length) {
            <p-inputIcon class="nav-menu__header-action-control" styleClass="pi pi-times" (click)="searchString = ''" />
          } @else {
            <p-inputIcon styleClass="pi pi-search" />
          }

          <input class="nav-menu__search" type="text" [(ngModel)]="searchString" pInputText placeholder="Search" />
        </p-iconField>
      }
    </ng-template>

    @for (button of selectedNavItem?.buttons; track button.url) {
      <p-button
        class="d-flex"
        styleClass="nav-menu__new-item-button"
        [rounded]="true"
        [label]="button.label"
        (onClick)="navigateToNewItem(selectedNavItem!.url, button.url)"
      />
      <p-divider />
    }

    <div class="nav-menu__group">
      <lh-panel-menu
        [menuItems]="selectedNavItem?.subNav?.items || [] | filterNavMenu: searchString"
        [favouriteSubmenu]="data.favouriteSubmenu | filterFavouriteSubmenu: selectedNavItem?.url || ''"
        (starIconClick)="onStarIconClick($event)"
      />
    </div>
    <p-divider />
  </p-sidebar>
}
